import React from 'react';
import { connect } from 'react-redux';
import { updateUsersRoleFilter } from '../actions';
import UserRow from '../components/UserRow';

const UsersTableRows = ({
  category,
  items,
  onCheckBoxClick,
  updateFilterRole,
  roleName,
  columns,
}) => (
  items.map((item, index) => (
    <UserRow
      key={`users_table_row_${item.code}`}
      category={category}
      user={item}
      onCheckBoxClick={onCheckBoxClick}
      updateFilterRole={updateFilterRole}
      upward={index > 4}
      columns={columns}
      roleName={roleName}
    />
  ))
);

const mapStateToProps = ({
  auth: { users },
}, { category }) => {
  const item = users[category] || { role: '' };
  return {
    roleName: item.role,
  };
};

const mapDispatchToProps = {
  updateFilterRole: updateUsersRoleFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersTableRows);
